<div id="content">
  <div class="page-title billing-header">
    <app-company-product-page-identity />
    <h1>{{ page_title }}</h1>
    <div class="header-actions">
      @if (show_month_navigation()) {
        <app-month-navigation
          [selected_month]="selected_month()"
          [can_go_to_next_month]="can_go_to_next_month()"
          [can_go_to_current_month]="can_go_to_current_month()"
          (previous_month)="goToPreviousMonth()"
          (next_month)="goToNextMonth()"
          (current_month)="goToCurrentMonth()"
        ></app-month-navigation>
      }
      @if (!show_company_product_filter()) {
        <button mat-stroked-button type="button" (click)="navigateToCompanyProductConciliation()">Conciliar facturas</button>
      }
    </div>
  </div>

  <div class="view-mode-toolbar">
    <span class="view-mode-label" [class.is-active]="!is_invoices_view()">Por periodo trabajado</span>
    <mat-slide-toggle
      [checked]="is_invoices_view()"
      (change)="onViewModeChange($event.checked)"
      aria-label="Cambiar entre vista por periodo trabajado y vista por facturas"
    ></mat-slide-toggle>
    <span class="view-mode-label" [class.is-active]="is_invoices_view()">Por facturas</span>
  </div>

  @if (!is_invoices_view()) {
    <div class="summary-cards">
      <app-metric-card title="Sin factura esperada" icon="receipt_long">
        <div class="big-numbers" [class.status-red]="summary_cards().missing_invoice_count > 0">
          <span>{{ summary_cards().missing_invoice_count }}</span>
        </div>
      </app-metric-card>
      <app-metric-card title="Pagos vencidos" icon="warning">
        <div class="big-numbers" [class.status-yellow]="summary_cards().overdue_payment_count > 0">
          <span>{{ summary_cards().overdue_payment_count }}</span>
        </div>
      </app-metric-card>
      <app-metric-card title="Conciliación pendiente" icon="sync_problem">
        <div class="big-numbers" [class.status-yellow]="summary_cards().pending_conciliation_count > 0">
          <span>{{ summary_cards().pending_conciliation_count }}</span>
        </div>
      </app-metric-card>
    </div>

    <div class="bisual-table">
      <div class="bisual-table-container">
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef>Mes</th>
            <td mat-cell *matCellDef="let row; dataSource: dataSource">{{ row.month_label }}</td>
          </ng-container>

          <ng-container matColumnDef="company_product">
            <th mat-header-cell *matHeaderCellDef>Producto</th>
            <td mat-cell *matCellDef="let row; dataSource: dataSource">
              <div class="company-product-cell">
                <div
                  class="company-product-logo"
                  [style.background-image]="row.company_product_logo_url ? 'url(' + row.company_product_logo_url + ')' : 'none'"
                ></div>
                <span>{{ row.company_product_title }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="hours">
            <th mat-header-cell *matHeaderCellDef>Horas</th>
            <td mat-cell *matCellDef="let row; dataSource: dataSource">
              <div class="hours-breakdown-cell">
                <div class="hours-breakdown-line">
                  <span class="hours-breakdown-label">Esperadas</span>
                  <div class="hours-breakdown-progress-wrapper">
                    <div class="hours-progress-track">
                      <div class="hours-progress-fill expected" [style.width.%]="row.hours_expected_progress"></div>
                    </div>
                    <span class="hours-breakdown-value">{{ row.hours_expected_label }}</span>
                  </div>
                </div>
                <div class="hours-breakdown-line">
                  <span class="hours-breakdown-label">Registradas</span>
                  <div class="hours-breakdown-progress-wrapper">
                    <div class="hours-progress-track">
                      <div class="hours-progress-fill registered" [style.width.%]="row.hours_registered_progress"></div>
                    </div>
                    <span class="hours-breakdown-value">{{ row.hours_registered_label }}</span>
                  </div>
                </div>
                <div class="hours-breakdown-line">
                  <span class="hours-breakdown-label">Facturadas</span>
                  <div class="hours-breakdown-progress-wrapper">
                    <div class="hours-progress-track">
                      <div class="hours-progress-fill billed" [style.width.%]="row.hours_billed_progress"></div>
                    </div>
                    <span class="hours-breakdown-value">{{ row.hours_billed_label }}</span>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="real_price_per_hour">
            <th mat-header-cell *matHeaderCellDef>€/h real</th>
            <td mat-cell *matCellDef="let row; dataSource: dataSource">{{ row.real_price_per_hour_label }}</td>
          </ng-container>

          <ng-container matColumnDef="invoice_price_per_hour">
            <th mat-header-cell *matHeaderCellDef>€/h factura</th>
            <td mat-cell *matCellDef="let row; dataSource: dataSource">{{ row.invoice_price_per_hour_label }}</td>
          </ng-container>

          <ng-container matColumnDef="payment_status">
            <th mat-header-cell *matHeaderCellDef>Pago</th>
            <td mat-cell *matCellDef="let row; dataSource: dataSource">
              @if (row.payment_status_icon) {
                <mat-icon [class]="row.payment_status_class" [matTooltip]="row.payment_status_tooltip ?? ''">
                  {{ row.payment_status_icon }}
                </mat-icon>
              } @else {
                <span class="status-badge" [class]="row.payment_status_class">{{ row.payment_status_label }}</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="conciliation_status">
            <th mat-header-cell *matHeaderCellDef>Conciliación</th>
            <td mat-cell *matCellDef="let row; dataSource: dataSource">
              <span class="status-badge" [class]="row.conciliation_status_class">{{ row.conciliation_status_label }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row; dataSource: dataSource" class="actions-cell">
              <div class="table-actions">
                <button mat-icon-button type="button" matTooltip="Ver detalle" aria-label="Ver detalle" (click)="navigateToDetail(row.id)">
                  <mat-icon>visibility</mat-icon>
                </button>
                @if (show_company_product_filter()) {
                  <button
                    mat-icon-button
                    type="button"
                    matTooltip="Conciliar facturas"
                    aria-label="Conciliar facturas"
                    (click)="navigateToConciliation(row.company_product_id)"
                  >
                    <mat-icon>sync_alt</mat-icon>
                  </button>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayed_columns()"></tr>
          <tr mat-row *matRowDef="let row; columns: displayed_columns()"></tr>
        </table>
      </div>
    </div>
  } @else {
    <div class="bisual-table">
      <div class="bisual-table-container">
        <table mat-table [dataSource]="invoice_data_source">
          <ng-container matColumnDef="month">
            <th mat-header-cell *matHeaderCellDef>Mes</th>
            <td mat-cell *matCellDef="let row; dataSource: invoice_data_source">{{ row.month_label }}</td>
          </ng-container>

          <ng-container matColumnDef="company_product">
            <th mat-header-cell *matHeaderCellDef>Producto</th>
            <td mat-cell *matCellDef="let row; dataSource: invoice_data_source">
              <div class="company-product-cell">
                <div
                  class="company-product-logo"
                  [style.background-image]="row.company_product_logo_url ? 'url(' + row.company_product_logo_url + ')' : 'none'"
                ></div>
                <span>{{ row.company_product_title }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="invoice_number">
            <th mat-header-cell *matHeaderCellDef>Nº factura</th>
            <td mat-cell *matCellDef="let row; dataSource: invoice_data_source">
              <div class="invoice-number-cell">
                <span>{{ row.invoice_number }}</span>
                @if (row.document_status_badge) {
                  <span [class]="row.document_status_class" [matTooltip]="row.document_status_tooltip ?? ''">{{
                    row.document_status_badge
                  }}</span>
                }
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="hours_billed">
            <th mat-header-cell *matHeaderCellDef>Horas facturadas</th>
            <td mat-cell *matCellDef="let row; dataSource: invoice_data_source">{{ row.hours_billed_label }}</td>
          </ng-container>

          <ng-container matColumnDef="hours_conciliated">
            <th mat-header-cell *matHeaderCellDef>Horas conciliadas</th>
            <td mat-cell *matCellDef="let row; dataSource: invoice_data_source">{{ row.hours_conciliated_label }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row; dataSource: invoice_data_source" class="actions-cell">
              <div class="table-actions">
                <button
                  mat-icon-button
                  type="button"
                  matTooltip="Ver conciliaciones por periodo"
                  aria-label="Ver conciliaciones por periodo"
                  (click)="openInvoiceConciliationsDialog(row)"
                >
                  <mat-icon>info</mat-icon>
                </button>
                @if (row.is_conciliation_pending && row.company_product_id !== null) {
                  <button
                    mat-icon-button
                    type="button"
                    matTooltip="Conciliar factura"
                    aria-label="Conciliar factura"
                    (click)="navigateToInvoiceConciliation(row.company_product_id)"
                  >
                    <mat-icon>sync_alt</mat-icon>
                  </button>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="invoice_displayed_columns()"></tr>
          <tr mat-row *matRowDef="let row; columns: invoice_displayed_columns()"></tr>
        </table>
      </div>
    </div>
  }
</div>
